const MODULE_NAME = 'ConflictsModule';

export const CONFLICTS_ADD_CONFLICT = `${MODULE_NAME}/CONFLICTS_ADD_CONFLICT`;
export const CONFLICTS_REMOVE_CONFLICT = `${MODULE_NAME}/CONFLICTS_REMOVE_CONFLICT`;
export const CONFLICTS_CLEAR_ALL_CONFLICTS = `${MODULE_NAME}/CONFLICTS_CLEAR_ALL_CONFLICTS`;
